import { render, staticRenderFns } from "./ContractMailPopup.vue?vue&type=template&id=68674d3a"
import script from "./ContractMailPopup.vue?vue&type=script&lang=ts"
export * from "./ContractMailPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports